export const DEVELOPMENT_MODE_ALIAS = 'development';
export const PRODUCTION_MODE_ALIAS = 'production';
export const AUTHENTICATION_STATE_KEY = 'session';
export const BEARER_COOKIE_KEY = 'tu_ap_bearer';